import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[scrollHandler]',
})
export class ScrollHandlerDirective {
  @Output() nearEnd: EventEmitter<void> = new EventEmitter<void>();
  @Input() tab: string | undefined;

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    let tracker = event.target;

    let limit = tracker.scrollHeight - tracker.clientHeight;
    if (
      this.tab &&
      this.tab === 'history' &&
      event.target.scrollTop >= limit - 1
    ) {
      this.nearEnd.emit();
    }
  }
}
